import { render, staticRenderFns } from "./PurchaseChange.vue?vue&type=template&id=555b9184"
import script from "./PurchaseChange.vue?vue&type=script&lang=js"
export * from "./PurchaseChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports